// extracted by mini-css-extract-plugin
module.exports = {"button":"nwrsK","inline":"FQ-k0","back":"e3X7l","next":"_8wR1C"};